export default "__VITE_ASSET__c47f3b34__"